import { atom, useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { deserializeFormParams } from "./ComparativeAnalysisForm.utils";

// parse the initial search params from the URL and populate the atoms
const INITIAL_SEARCH_PARAMS = new URLSearchParams(window.location.search);
const INITIAL_FORM_FLAT = deserializeFormParams(INITIAL_SEARCH_PARAMS);

type SearchParamAtomValue = string | undefined;

// below primitive atoms are used to store the local state of the form,
// so the URL is not updated when the form fields change (but only when the form is submitted)
export const env1Atom = atom<SearchParamAtomValue>(INITIAL_FORM_FLAT.env1);
export const pipeline1Atom = atom<SearchParamAtomValue>(INITIAL_FORM_FLAT.pipeline1);
export const pipelineId1Atom = atom<SearchParamAtomValue>(undefined); // not used in search params
export const pit1Atom = atom<SearchParamAtomValue>(INITIAL_FORM_FLAT.pit1);
export const task1Atom = atom<SearchParamAtomValue>(INITIAL_FORM_FLAT.task1);

export const env2Atom = atom<SearchParamAtomValue>(INITIAL_FORM_FLAT.env2);
export const pipeline2Atom = atom<SearchParamAtomValue>(INITIAL_FORM_FLAT.pipeline2);
export const pipelineId2Atom = atom<SearchParamAtomValue>(undefined); // not used in search params
export const pit2Atom = atom<SearchParamAtomValue>(INITIAL_FORM_FLAT.pit2);
export const task2Atom = atom<SearchParamAtomValue>(INITIAL_FORM_FLAT.task2);

// returns all the above atoms' values & setters as a grouped-object
export const useFormStateAtoms = () => {
  const env1 = useAtom(env1Atom);
  const pipeline1 = useAtom(pipeline1Atom);
  const pipelineId1 = useAtom(pipelineId1Atom);
  const pit1 = useAtom(pit1Atom);
  const task1 = useAtom(task1Atom);

  const env2 = useAtom(env2Atom);
  const pipeline2 = useAtom(pipeline2Atom);
  const pipelineId2 = useAtom(pipelineId2Atom);
  const pit2 = useAtom(pit2Atom);
  const task2 = useAtom(task2Atom);

  return {
    env1,
    pipeline1,
    pipelineId1,
    pit1,
    task1,

    env2,
    pipeline2,
    pipelineId2,
    pit2,
    task2,
  };
};

export const comparisonHistoryAtom = atomWithStorage<string[]>(
  "comparative-analysis-history/v1",
  []
);

// validation-related atoms
export const isValidEnv1 = atom<boolean | undefined>();
export const isValidPipeline1 = atom<boolean | undefined>();
export const isValidPit1 = atom<boolean | undefined>();
export const isValidTask1 = atom<boolean | undefined>();

export const isValidEnv2 = atom<boolean | undefined>();
export const isValidPipeline2 = atom<boolean | undefined>();
export const isValidPit2 = atom<boolean | undefined>();
export const isValidTask2 = atom<boolean | undefined>();

export const comparePitsFormSubmittedAtom = atom(true);
